module.exports = __webpack_public_path__ + "static/Zimt-(mit-Pflaume)-8a8a525274ca77060e9a4442c1f1de45.png";